export default __webpack_public_path__ + "static/media/2245.3a9f8749.png";